import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getContainerDetailData(containerLabel, nodeId) {
    const requestBody = {
        "containerLabel": containerLabel,
        "nodeId": nodeId
    }
    const startTime = Date.now();
    
    const request = {
        resourcePath: "/os/getContainerDetailData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerDetailData", true);
            return response.data.containerDetail.containerData;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerDetailData", false);
            return {};
        }
    } catch (error) {
        return {};
    }

}


// WEBPACK FOOTER //
// ./src/commons/api/GetContainerDetailsResults.js